import { useTranslation } from 'react-i18next';
import { getEdlpTable } from '../tables/table';
import Modal from '../common/Modal';
import ViewTable from '../tables/ViewTable';

const ChomeModal = ({ isShow, onClose, onSubmit, modalData, isFreshness }) => {
    const { t } = useTranslation();
    const edlpTable = getEdlpTable(t, isFreshness);

    return (
        <Modal
            size="xl"
            isShow={isShow}
            onClose={onClose}
            isShowIconClose="true"
            title={t('modal.common_modal.title')}
            btnList={[
                {
                    name: t('button.apply'),
                    className: 'btn--primary',
                    onClick: onSubmit,
                    disabled: false,
                },
                {
                    name: t('button.cancel'),
                    className: 'btn--secondary',
                    onClick: onClose,
                    disabled: false,
                },
            ]}
            children={
                <>
                    <p className="text-center">超目商品が含まれています。</p>
                    <p className="text-center">申請しますか。</p>
                    <ViewTable heads={edlpTable.heads} body={edlpTable.body} dataTable={modalData} />
                </>
            }
        />
    );
};

export default ChomeModal;
